import profile from '../assets/profile.svg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import nuclear from '../assets/nuclear.svg';
import software from '../assets/software.svg';
import presentation from '../assets/presentation.svg';

import anonymous from '../assets/anonymous.png';
import cancer from '../assets/cancer.png';
import language from '../assets/language.png';
import loan from '../assets/loan.png';
import movie from '../assets/movie.png';
import paper from '../assets/paper.png';
import poster from '../assets/poster.png';
import recession from '../assets/recession.png';
import shield from '../assets/shield.png';
import todo from '../assets/todo.png';
import website from '../assets/website.png';
import xenus from '../assets/xenus.png';

import c from '../assets/c++.svg';
import canva from '../assets/canva.svg';
import excel from '../assets/excel.svg';
import fusion360 from '../assets/fusion360.svg';
import matlab from '../assets/matlab.svg';
import python from '../assets/python.svg';
import react from '../assets/react.svg';
import sanity from '../assets/sanity.svg';
import sass from '../assets/sass.svg';
import javascript from '../assets/javascript.png';
import postgresql from '../assets/postgresql.png';

import shopping from '../assets/shopping.png';

import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

export default {
  profile,
  circle,
  logo,
  nuclear,
  software,
  presentation,
  anonymous,
  cancer,
  language,
  loan,
  movie,
  paper,
  poster,
  recession,
  shield,
  todo,
  website,
  xenus,
  c,
  canva,
  excel,
  fusion360,
  matlab,
  python,
  react,
  sanity,
  sass,
  javascript,
  postgresql,
  shopping,
  email,
  mobile,
};